module.exports = "#pending-punchin .ibox-content{\n        max-height: 295px;\n        overflow-y: auto;\n    }\n#emp-leave .ibox-content{\n        max-height: 295px;\n        overflow-y: auto;\n    }"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/maindashboard/pending-puchin/pending-puchin.component.css
// module id = ./src/app/modules/dashboard/components/maindashboard/pending-puchin/pending-puchin.component.css
// module chunks = main